export default "__VITE_ASSET__Dvf_FahG__"